import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "styled-components";
import {
  Box,
  Stack,
  Module,
  EditNameForm,
  ButtonWithAction,
  withWindowSize,
  util,
  constants
} from "@thecb/components";
import S from "/util/Sanctuary";
import { NAME_SETTING } from "../../Profile.state";
import AlertBar from "/components/alert-bar";

const EditName = ({
  resources,
  resourcesActions,
  requests,
  forms,
  actions,
  alertBars,
  handleFocusErrors
}) => {
  let navigate = useNavigate();
  const person = resources;
  const { onSubmitChange } = resourcesActions;
  const requestStatusName = requests[NAME_SETTING] || S.RemoteData.NotAsked;
  const { editNameForm: form } = forms;
  const {
    forms: { editNameForm: formActions },
    alertBars: { editNameAlertBar: alertBarActions }
  } = actions;
  const { editNameAlertBar: alertBar } = alertBars;
  const [errors, handleErrors] = useState(false);
  const { isMobile } = useContext(ThemeContext);

  useEffect(() => {
    formActions.actions.fields.firstName.set(person.firstName);
    formActions.actions.fields.lastName.set(person.lastName);
  }, [person.constituentId]);

  const handleSubmit = util.general.generateClickHandler(
    form,
    () => {
      handleErrors(true);
      handleFocusErrors(true);
    },
    () => onSubmitChange(NAME_SETTING)
  );

  return (
    <Box padding="0 0 16px" width={isMobile ? "100%" : "576px"} role="main">
      {alertBar.alerts.length > 0 && (
        <Box padding="1rem 0 0">
          <AlertBar {...alertBar} {...alertBarActions} />
        </Box>
      )}
      <Module heading="Edit Name" as="h1">
        <EditNameForm
          clearOnDismount
          {...form}
          {...formActions}
          showErrors={errors}
          handleSubmit={handleSubmit}
          isMobile={isMobile}
        />
      </Module>
      <Box
        padding="1.5rem 0 0 0"
        borderColor={constants.colors.GHOST_GREY}
        borderSize="1px"
        borderWidthOverride="1px 0 0 0"
      >
        {isMobile ? (
          <Stack childGap="1rem" direction="row">
            <Box width="100%" padding="0">
              <ButtonWithAction
                text="Cancel"
                action={() => navigate(-1)}
                variant={"secondary"}
                dataQa="Cancel"
                extraStyles={`width: 100%;`}
              />
            </Box>
            <Box width="100%" padding="0">
              <ButtonWithAction
                text="Save"
                action={handleSubmit}
                isLoading={requestStatusName.isLoading}
                variant="primary"
                dataQa="Save"
                extraStyles={`width: 100%;`}
              />
            </Box>
          </Stack>
        ) : (
          <Stack childGap="1rem" direction="row" justify="flex-end">
            <ButtonWithAction
              text="Cancel"
              action={() => navigate(-1)}
              variant={"secondary"}
              dataQa="Cancel"
            />
            <ButtonWithAction
              text="Save"
              action={handleSubmit}
              isLoading={requestStatusName.isLoading}
              variant="primary"
              dataQa="Save"
            />
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default withWindowSize(EditName);
